module.exports = __webpack_public_path__ + "static/img/green1.ed927e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/green1.jpg
// module id = 8o6d
// module chunks = 1